import { toast } from 'react-toastify';

export const successToast = (msg = 'Saved Successfully') => {
  toast(msg, {
    position: 'bottom-right',
    bodyClassName: 'property-saved-msg',
    className: 'save-success',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    pauseOnFocusLoss: false,
  });
};

export const OnlineToast = () =>
  toast('You are back online', {
    position: 'bottom-right',
    className: 'network-status',
    bodyClassName: 'network-online',
    closeOnClick: false,
    autoClose: 2000,
    pauseOnFocusLoss: false,
    toastId: 'online',
    hideProgressBar: true,
  });

export const OfflineToast = () =>
  toast('You are offline', {
    position: 'bottom-right',
    className: 'network-status',
    bodyClassName: 'network-offline',
    closeOnClick: false,
    autoClose: 5000,
    pauseOnFocusLoss: false,
    toastId: 'offline',
    hideProgressBar: true,
  });

export const AuthToast = msg =>
  toast(msg, {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    closeButton: false,
    className: 'login-toast',
    bodyClassName: 'login-toast-body',
    pauseOnFocusLoss: false,
    toastId: 'login-toast',
  });

export const errorToast = msg =>
  toast(msg, {
    position: 'bottom-right',
    className: 'generic-error-toast',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    pauseOnFocusLoss: false,
  });
